/** Categories offered when submitting a card, in the order they should appear in filters. */
const KNOWN_CARD_TYPES = [
  { key: 'Sports', label: 'Sports' },
  { key: 'Pokemon', label: 'Pokémon' },
  { key: 'Magic', label: 'Magic: The Gathering' },
  { key: 'YuGiOh', label: 'Yu-Gi-Oh!' },
  { key: 'DragonBall', label: 'Dragon Ball' },
  { key: 'OnePiece', label: 'One Piece' },
]

export const OTHER_CARD_TYPE = 'Other'

function humanize(text) {
  return text.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ')
}

/** Stable grouping key for a card's raw `cardType` ("sports", "Sports " and "SPORTS" match). */
export function getCardTypeKey(rawType) {
  const trimmed = String(rawType ?? '').trim()
  if (!trimmed) return OTHER_CARD_TYPE
  const lower = trimmed.toLowerCase()
  const known = KNOWN_CARD_TYPES.find((type) => type.key.toLowerCase() === lower)
  if (known) return known.key
  if (lower === OTHER_CARD_TYPE.toLowerCase()) return OTHER_CARD_TYPE
  return trimmed
}

export function getCardTypeLabel(key) {
  const known = KNOWN_CARD_TYPES.find((type) => type.key === key)
  return known ? known.label : humanize(key)
}

/** Sort order for filter chips: known categories first, then the rest A–Z, "Other" last. */
export function compareCardTypeKeys(a, b) {
  const rank = (key) => {
    if (key === OTHER_CARD_TYPE) return 1000
    const index = KNOWN_CARD_TYPES.findIndex((type) => type.key === key)
    return index === -1 ? 500 : index
  }
  const diff = rank(a) - rank(b)
  return diff !== 0 ? diff : a.localeCompare(b, undefined, { sensitivity: 'base' })
}
